import React from 'react';

/**
 * HeroImage Component
 * 
 * A specialized image component for hero images that:
 * - Loads immediately (no lazy loading)
 * - Preserves 13:7 aspect ratio to prevent layout shift
 * - Provides smooth loading experience
 * 
 * @param {string} src - Image source URL
 * @param {string} alt - Alt text for accessibility
 * @param {string} className - Additional CSS classes
 * @param {function} onLoad - Optional load callback
 * @param {function} onError - Optional error callback
 */
const HeroImage = ({ 
  src, 
  alt = '', 
  className = '', 
  onLoad,
  onError,
  ...props 
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`hero-img ${className}`}
      loading="eager"
      onLoad={onLoad}
      onError={onError}
      {...props}
    />
  );
};

export default HeroImage;
